import abi from "./Web3Task.json"
import Web3Task from "./contract-Web3Task-address.json"

export const Contract137 = {
    "address": Web3Task.Web3Task,
    "abi": abi.abi,
    "abiTask": abi.abi,
} as const